// RAD Type Action Types
export const FETCH_RADTYPES_REQUEST = "FETCH_RADTYPES_REQUEST";
export const FETCH_RADTYPES_SUCCESS = "FETCH_RADTYPES_SUCCESS";
export const FETCH_RADTYPES_FAILURE = "FETCH_RADTYPES_FAILURE";

export const DELETE_RADTYPE_REQUEST = "DELETE_RADTYPE_REQUEST";
export const DELETE_RADTYPE_SUCCESS = "DELETE_RADTYPE_SUCCESS";
export const DELETE_RADTYPE_FAILURE = "DELETE_RADTYPE_FAILURE";

export const SAVE_RADTYPE_REQUEST = "SAVE_RADTYPE_REQUEST";
export const SAVE_RADTYPE_SUCCESS = "SAVE_RADTYPE_SUCCESS";
export const SAVE_RADTYPE_FAILURE = "SAVE_RADTYPE_FAILURE";

export const FETCH_RADTYPE_BY_ID_REQUEST = "FETCH_RADTYPE_BY_ID_REQUEST";
export const FETCH_RADTYPE_BY_ID_SUCCESS = "FETCH_RADTYPE_BY_ID_SUCCESS";
export const FETCH_RADTYPE_BY_ID_FAILURE = "FETCH_RADTYPE_BY_ID_FAILURE";

export const UPDATE_RADTYPE_REQUEST = "UPDATE_RADTYPE_REQUEST";
export const UPDATE_RADTYPE_SUCCESS = "UPDATE_RADTYPE_SUCCESS";
export const UPDATE_RADTYPE_FAILURE = "UPDATE_RADTYPE_FAILURE";

export const ACTIVATE_DEACTIVATE_RADTYPE_REQUEST =
  "ACTIVATE_DEACTIVATE_RADTYPE_REQUEST";
export const ACTIVATE_DEACTIVATE_RADTYPE_SUCCESS =
  "ACTIVATE_DEACTIVATE_RADTYPE_SUCCESS";
export const ACTIVATE_DEACTIVATE_RADTYPE_FAILURE =
  "ACTIVATE_DEACTIVATE_RADTYPE_FAILURE";

// RAD Status Action Types
export const FETCH_RADSTATUS_REQUEST = "FETCH_RADSTATUS_REQUEST";
export const FETCH_RADSTATUS_SUCCESS = "FETCH_RADSTATUS_SUCCESS";
export const FETCH_RADSTATUS_FAILURE = "FETCH_RADSTATUS_FAILURE";

export const DELETE_RADSTATUS_REQUEST = "DELETE_RADSTATUS_REQUEST";
export const DELETE_RADSTATUS_SUCCESS = "DELETE_RADSTATUS_SUCCESS";
export const DELETE_RADSTATUS_FAILURE = "DELETE_RADSTATUS_FAILURE";

export const SAVE_RADSTATUS_REQUEST = "SAVE_RADSTATUS_REQUEST";
export const SAVE_RADSTATUS_SUCCESS = "SAVE_RADSTATUS_SUCCESS";
export const SAVE_RADSTATUS_FAILURE = "SAVE_RADSTATUS_FAILURE";

export const FETCH_RADSTATUS_BY_ID_REQUEST = "FETCH_RADSTATUS_BY_ID_REQUEST";
export const FETCH_RADSTATUS_BY_ID_SUCCESS = "FETCH_RADSTATUS_BY_ID_SUCCESS";
export const FETCH_RADSTATUS_BY_ID_FAILURE = "FETCH_RADSTATUS_BY_ID_FAILURE";

export const UPDATE_RADSTATUS_REQUEST = "UPDATE_RADSTATUS_REQUEST";
export const UPDATE_RADSTATUS_SUCCESS = "UPDATE_RADSTATUS_SUCCESS";
export const UPDATE_RADSTATUS_FAILURE = "UPDATE_RADSTATUS_FAILURE";

export const ACTIVATE_DEACTIVATE_RADSTATUS_REQUEST =
  "ACTIVATE_DEACTIVATE_RADSTATUS_REQUEST";
export const ACTIVATE_DEACTIVATE_RADSTATUS_SUCCESS =
  "ACTIVATE_DEACTIVATE_RADSTATUS_SUCCESS";
export const ACTIVATE_DEACTIVATE_RADSTATUS_FAILURE =
  "ACTIVATE_DEACTIVATE_RADSTATUS_FAILURE";

export const FETCH_SUBSPECIALITIES_REQUEST = "FETCH_SUBSPECIALITIES_REQUEST";
export const FETCH_SUBSPECIALITIES_SUCCESS = "FETCH_SUBSPECIALITIES_SUCCESS";
export const FETCH_SUBSPECIALITIES_FAILURE = "FETCH_SUBSPECIALITIES_FAILURE";

export const FETCH_SUBSPECIALITY_BY_ID_REQUEST =
  "FETCH_SUBSPECIALITY_BY_ID_REQUEST";
export const FETCH_SUBSPECIALITY_BY_ID_SUCCESS =
  "FETCH_SUBSPECIALITY_BY_ID_SUCCESS";
export const FETCH_SUBSPECIALITY_BY_ID_FAILURE =
  "FETCH_SUBSPECIALITY_BY_ID_FAILURE";

export const SAVE_SUBSPECIALITY_REQUEST = "SAVE_SUBSPECIALITY_REQUEST";
export const SAVE_SUBSPECIALITY_SUCCESS = "SAVE_SUBSPECIALITY_SUCCESS";
export const SAVE_SUBSPECIALITY_FAILURE = "SAVE_SUBSPECIALITY_FAILURE";

export const DELETE_SUBSPECIALITY_REQUEST = "DELETE_SUBSPECIALITY_REQUEST";
export const DELETE_SUBSPECIALITY_SUCCESS = "DELETE_SUBSPECIALITY_SUCCESS";
export const DELETE_SUBSPECIALITY_FAILURE = "DELETE_SUBSPECIALITY_FAILURE";

export const ACTIVATE_DEACTIVATE_SUBSPECIALITY_REQUEST =
  "ACTIVATE_DEACTIVATE_SUBSPECIALITY_REQUEST";
export const ACTIVATE_DEACTIVATE_SUBSPECIALITY_SUCCESS =
  "ACTIVATE_DEACTIVATE_SUBSPECIALITY_SUCCESS";
export const ACTIVATE_DEACTIVATE_SUBSPECIALITY_FAILURE =
  "ACTIVATE_DEACTIVATE_SUBSPECIALITY_FAILURE";

export const FETCH_BILLING_MANAGEMENT_REQUEST =
  "FETCH_BILLING_MANAGEMENT_REQUEST";
export const FETCH_BILLING_MANAGEMENT_SUCCESS =
  "FETCH_BILLING_MANAGEMENT_SUCCESS";
export const FETCH_BILLING_MANAGEMENT_FAILURE =
  "FETCH_BILLING_MANAGEMENT_FAILURE";

export const FETCH_BILLING_MANAGEMENT_BY_ID_REQUEST =
  "FETCH_BILLING_MANAGEMENT_BY_ID_REQUEST";
export const FETCH_BILLING_MANAGEMENT_BY_ID_SUCCESS =
  "FETCH_BILLING_MANAGEMENT_BY_ID_SUCCESS";
export const FETCH_BILLING_MANAGEMENT_BY_ID_FAILURE =
  "FETCH_BILLING_MANAGEMENT_BY_ID_FAILURE";

export const SAVE_BILLING_MANAGEMENT_REQUEST =
  "SAVE_BILLING_MANAGEMENT_REQUEST";
export const SAVE_BILLING_MANAGEMENT_SUCCESS =
  "SAVE_BILLING_MANAGEMENT_SUCCESS";
export const SAVE_BILLING_MANAGEMENT_FAILURE =
  "SAVE_BILLING_MANAGEMENT_FAILURE";

export const DELETE_BILLING_MANAGEMENT_REQUEST =
  "DELETE_BILLING_MANAGEMENT_REQUEST";
export const DELETE_BILLING_MANAGEMENT_SUCCESS =
  "DELETE_BILLING_MANAGEMENT_SUCCESS";
export const DELETE_BILLING_MANAGEMENT_FAILURE =
  "DELETE_BILLING_MANAGEMENT_FAILURE";

export const ACTIVATE_DEACTIVATE_BILLING_MANAGEMENT_REQUEST =
  "ACTIVATE_DEACTIVATE_BILLING_MANAGEMENT_REQUEST";
export const ACTIVATE_DEACTIVATE_BILLING_MANAGEMENT_SUCCESS =
  "ACTIVATE_DEACTIVATE_BILLING_MANAGEMENT_SUCCESS";
export const ACTIVATE_DEACTIVATE_BILLING_MANAGEMENT_FAILURE =
  "ACTIVATE_DEACTIVATE_BILLING_MANAGEMENT_FAILURE";

// Week Rotation Action Types
export const FETCH_WEEK_ROTATIONS_REQUEST = "FETCH_WEEK_ROTATIONS_REQUEST";
export const FETCH_WEEK_ROTATIONS_SUCCESS = "FETCH_WEEK_ROTATIONS_SUCCESS";
export const FETCH_WEEK_ROTATIONS_FAILURE = "FETCH_WEEK_ROTATIONS_FAILURE";

export const FETCH_WEEK_ROTATION_BY_ID_REQUEST =
  "FETCH_WEEK_ROTATION_BY_ID_REQUEST";
export const FETCH_WEEK_ROTATION_BY_ID_SUCCESS =
  "FETCH_WEEK_ROTATION_BY_ID_SUCCESS";
export const FETCH_WEEK_ROTATION_BY_ID_FAILURE =
  "FETCH_WEEK_ROTATION_BY_ID_FAILURE";

export const SAVE_WEEK_ROTATION_REQUEST = "SAVE_WEEK_ROTATION_REQUEST";
export const SAVE_WEEK_ROTATION_SUCCESS = "SAVE_WEEK_ROTATION_SUCCESS";
export const SAVE_WEEK_ROTATION_FAILURE = "SAVE_WEEK_ROTATION_FAILURE";

export const DELETE_WEEK_ROTATION_REQUEST = "DELETE_WEEK_ROTATION_REQUEST";
export const DELETE_WEEK_ROTATION_SUCCESS = "DELETE_WEEK_ROTATION_SUCCESS";
export const DELETE_WEEK_ROTATION_FAILURE = "DELETE_WEEK_ROTATION_FAILURE";

export const ACTIVATE_DEACTIVATE_WEEK_ROTATION_REQUEST =
  "ACTIVATE_DEACTIVATE_WEEK_ROTATION_REQUEST";
export const ACTIVATE_DEACTIVATE_WEEK_ROTATION_SUCCESS =
  "ACTIVATE_DEACTIVATE_WEEK_ROTATION_SUCCESS";
export const ACTIVATE_DEACTIVATE_WEEK_ROTATION_FAILURE =
  "ACTIVATE_DEACTIVATE_WEEK_ROTATION_FAILURE";

// Week Rotation Template Action Types
export const FETCH_WEEK_ROTATION_TEMPLATES_REQUEST =
  "FETCH_WEEK_ROTATION_TEMPLATES_REQUEST";
export const FETCH_WEEK_ROTATION_TEMPLATES_SUCCESS =
  "FETCH_WEEK_ROTATION_TEMPLATES_SUCCESS";
export const FETCH_WEEK_ROTATION_TEMPLATES_FAILURE =
  "FETCH_WEEK_ROTATION_TEMPLATES_FAILURE";

export const FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_REQUEST =
  "FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_REQUEST";
export const FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_SUCCESS =
  "FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_SUCCESS";
export const FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_FAILURE =
  "FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_FAILURE";

export const DELETE_WEEK_ROTATION_TEMPLATE_REQUEST =
  "DELETE_WEEK_ROTATION_TEMPLATE_REQUEST";
export const DELETE_WEEK_ROTATION_TEMPLATE_SUCCESS =
  "DELETE_WEEK_ROTATION_TEMPLATE_SUCCESS";
export const DELETE_WEEK_ROTATION_TEMPLATE_FAILURE =
  "DELETE_WEEK_ROTATION_TEMPLATE_FAILURE";

export const ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_REQUEST =
  "ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_REQUEST";
export const ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_SUCCESS =
  "ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_SUCCESS";
export const ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_FAILURE =
  "ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_FAILURE";

export const SAVE_WEEK_ROTATION_TEMPLATE_REQUEST =
  "SAVE_WEEK_ROTATION_TEMPLATE_REQUEST";
export const SAVE_WEEK_ROTATION_TEMPLATE_SUCCESS =
  "SAVE_WEEK_ROTATION_TEMPLATE_SUCCESS";
export const SAVE_WEEK_ROTATION_TEMPLATE_FAILURE =
  "SAVE_WEEK_ROTATION_TEMPLATE_FAILURE";

// Partnership Rate Action Types
export const FETCH_PARTNERSHIP_RATES_REQUEST =
  "FETCH_PARTNERSHIP_RATES_REQUEST";
export const FETCH_PARTNERSHIP_RATES_SUCCESS =
  "FETCH_PARTNERSHIP_RATES_SUCCESS";
export const FETCH_PARTNERSHIP_RATES_FAILURE =
  "FETCH_PARTNERSHIP_RATES_FAILURE";

export const FETCH_PARTNERSHIP_RATE_BY_ID_REQUEST =
  "FETCH_PARTNERSHIP_RATE_BY_ID_REQUEST";
export const FETCH_PARTNERSHIP_RATE_BY_ID_SUCCESS =
  "FETCH_PARTNERSHIP_RATE_BY_ID_SUCCESS";
export const FETCH_PARTNERSHIP_RATE_BY_ID_FAILURE =
  "FETCH_PARTNERSHIP_RATE_BY_ID_FAILURE";

export const SAVE_PARTNERSHIP_RATE_REQUEST = "SAVE_PARTNERSHIP_RATE_REQUEST";
export const SAVE_PARTNERSHIP_RATE_SUCCESS = "SAVE_PARTNERSHIP_RATE_SUCCESS";
export const SAVE_PARTNERSHIP_RATE_FAILURE = "SAVE_PARTNERSHIP_RATE_FAILURE";

export const DELETE_PARTNERSHIP_RATE_REQUEST =
  "DELETE_PARTNERSHIP_RATE_REQUEST";
export const DELETE_PARTNERSHIP_RATE_SUCCESS =
  "DELETE_PARTNERSHIP_RATE_SUCCESS";
export const DELETE_PARTNERSHIP_RATE_FAILURE =
  "DELETE_PARTNERSHIP_RATE_FAILURE";

export const ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_REQUEST =
  "ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_REQUEST";
export const ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_SUCCESS =
  "ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_SUCCESS";
export const ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_FAILURE =
  "ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_FAILURE";

// Partnership Status Action Types
export const FETCH_PARTNERSHIP_STATUSES_REQUEST =
  "FETCH_PARTNERSHIP_STATUSES_REQUEST";
export const FETCH_PARTNERSHIP_STATUSES_SUCCESS =
  "FETCH_PARTNERSHIP_STATUSES_SUCCESS";
export const FETCH_PARTNERSHIP_STATUSES_FAILURE =
  "FETCH_PARTNERSHIP_STATUSES_FAILURE";

export const FETCH_PARTNERSHIP_STATUS_BY_ID_REQUEST =
  "FETCH_PARTNERSHIP_STATUS_BY_ID_REQUEST";
export const FETCH_PARTNERSHIP_STATUS_BY_ID_SUCCESS =
  "FETCH_PARTNERSHIP_STATUS_BY_ID_SUCCESS";
export const FETCH_PARTNERSHIP_STATUS_BY_ID_FAILURE =
  "FETCH_PARTNERSHIP_STATUS_BY_ID_FAILURE";

export const SAVE_PARTNERSHIP_STATUS_REQUEST =
  "SAVE_PARTNERSHIP_STATUS_REQUEST";
export const SAVE_PARTNERSHIP_STATUS_SUCCESS =
  "SAVE_PARTNERSHIP_STATUS_SUCCESS";
export const SAVE_PARTNERSHIP_STATUS_FAILURE =
  "SAVE_PARTNERSHIP_STATUS_FAILURE";

export const DELETE_PARTNERSHIP_STATUS_REQUEST =
  "DELETE_PARTNERSHIP_STATUS_REQUEST";
export const DELETE_PARTNERSHIP_STATUS_SUCCESS =
  "DELETE_PARTNERSHIP_STATUS_SUCCESS";
export const DELETE_PARTNERSHIP_STATUS_FAILURE =
  "DELETE_PARTNERSHIP_STATUS_FAILURE";

export const ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_REQUEST =
  "ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_REQUEST";
export const ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_SUCCESS =
  "ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_SUCCESS";
export const ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_FAILURE =
  "ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_FAILURE";

// Partnership Time Action Types
export const FETCH_PARTNERSHIP_TIMES_REQUEST =
  "FETCH_PARTNERSHIP_TIMES_REQUEST";
export const FETCH_PARTNERSHIP_TIMES_SUCCESS =
  "FETCH_PARTNERSHIP_TIMES_SUCCESS";
export const FETCH_PARTNERSHIP_TIMES_FAILURE =
  "FETCH_PARTNERSHIP_TIMES_FAILURE";

export const FETCH_PARTNERSHIP_TIME_BY_ID_REQUEST =
  "FETCH_PARTNERSHIP_TIME_BY_ID_REQUEST";
export const FETCH_PARTNERSHIP_TIME_BY_ID_SUCCESS =
  "FETCH_PARTNERSHIP_TIME_BY_ID_SUCCESS";
export const FETCH_PARTNERSHIP_TIME_BY_ID_FAILURE =
  "FETCH_PARTNERSHIP_TIME_BY_ID_FAILURE";

export const SAVE_PARTNERSHIP_TIME_REQUEST = "SAVE_PARTNERSHIP_TIME_REQUEST";
export const SAVE_PARTNERSHIP_TIME_SUCCESS = "SAVE_PARTNERSHIP_TIME_SUCCESS";
export const SAVE_PARTNERSHIP_TIME_FAILURE = "SAVE_PARTNERSHIP_TIME_FAILURE";

export const DELETE_PARTNERSHIP_TIME_REQUEST =
  "DELETE_PARTNERSHIP_TIME_REQUEST";
export const DELETE_PARTNERSHIP_TIME_SUCCESS =
  "DELETE_PARTNERSHIP_TIME_SUCCESS";
export const DELETE_PARTNERSHIP_TIME_FAILURE =
  "DELETE_PARTNERSHIP_TIME_FAILURE";

export const ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_REQUEST =
  "ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_REQUEST";
export const ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_SUCCESS =
  "ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_SUCCESS";
export const ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_FAILURE =
  "ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_FAILURE";

// radDegree Action Types - START
export const FETCH_RAD_DEGREE_REQUEST = "FETCH_RAD_DEGREE_REQUEST";
export const FETCH_RAD_DEGREE_SUCCESS = "FETCH_RAD_DEGREE_SUCCESS";
export const FETCH_RAD_DEGREE_FAILURE = "FETCH_RAD_DEGREE_FAILURE";

export const DELETE_RAD_DEGREE_REQUEST = "DELETE_RAD_DEGREE_REQUEST";
export const DELETE_RAD_DEGREE_SUCCESS = "DELETE_RAD_DEGREE_SUCCESS";
export const DELETE_RAD_DEGREE_FAILURE = "DELETE_RAD_DEGREE_FAILURE";

export const SAVE_RAD_DEGREE_REQUEST = "SAVE_RAD_DEGREE_REQUEST";
export const SAVE_RAD_DEGREE_SUCCESS = "SAVE_RAD_DEGREE_SUCCESS";
export const SAVE_RAD_DEGREE_FAILURE = "SAVE_RAD_DEGREE_FAILURE";

export const FETCH_RAD_DEGREE_BY_ID_REQUEST = "FETCH_RAD_DEGREE_BY_ID_REQUEST";
export const FETCH_RAD_DEGREE_BY_ID_SUCCESS = "FETCH_RAD_DEGREE_BY_ID_SUCCESS";
export const FETCH_RAD_DEGREE_BY_ID_FAILURE = "FETCH_RAD_DEGREE_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_RAD_DEGREE_REQUEST =
  "ACTIVATE_DEACTIVATE_RAD_DEGREE_REQUEST";
export const ACTIVATE_DEACTIVATE_RAD_DEGREE_SUCCESS =
  "ACTIVATE_DEACTIVATE_RAD_DEGREE_SUCCESS";
export const ACTIVATE_DEACTIVATE_RAD_DEGREE_FAILURE =
  "ACTIVATE_DEACTIVATE_RAD_DEGREE_FAILURE";
// radDegree Action Types - END

// designationLookup Action Types (dropdown source for the Add/Edit Designation
// form, reusing the RadUser/GetRadUserByID bundle's Master_UserDesignation
// dropdown -- the same source the old User Management "Designation" field
// used to read from) - START
export const FETCH_DESIGNATION_LOOKUP_REQUEST = "FETCH_DESIGNATION_LOOKUP_REQUEST";
export const FETCH_DESIGNATION_LOOKUP_SUCCESS = "FETCH_DESIGNATION_LOOKUP_SUCCESS";
export const FETCH_DESIGNATION_LOOKUP_FAILURE = "FETCH_DESIGNATION_LOOKUP_FAILURE";
// designationLookup Action Types - END

// designation Action Types - START
export const FETCH_DESIGNATION_REQUEST = "FETCH_DESIGNATION_REQUEST";
export const FETCH_DESIGNATION_SUCCESS = "FETCH_DESIGNATION_SUCCESS";
export const FETCH_DESIGNATION_FAILURE = "FETCH_DESIGNATION_FAILURE";

export const DELETE_DESIGNATION_REQUEST = "DELETE_DESIGNATION_REQUEST";
export const DELETE_DESIGNATION_SUCCESS = "DELETE_DESIGNATION_SUCCESS";
export const DELETE_DESIGNATION_FAILURE = "DELETE_DESIGNATION_FAILURE";

export const SAVE_DESIGNATION_REQUEST = "SAVE_DESIGNATION_REQUEST";
export const SAVE_DESIGNATION_SUCCESS = "SAVE_DESIGNATION_SUCCESS";
export const SAVE_DESIGNATION_FAILURE = "SAVE_DESIGNATION_FAILURE";

export const FETCH_DESIGNATION_BY_ID_REQUEST = "FETCH_DESIGNATION_BY_ID_REQUEST";
export const FETCH_DESIGNATION_BY_ID_SUCCESS = "FETCH_DESIGNATION_BY_ID_SUCCESS";
export const FETCH_DESIGNATION_BY_ID_FAILURE = "FETCH_DESIGNATION_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_DESIGNATION_REQUEST =
  "ACTIVATE_DEACTIVATE_DESIGNATION_REQUEST";
export const ACTIVATE_DEACTIVATE_DESIGNATION_SUCCESS =
  "ACTIVATE_DEACTIVATE_DESIGNATION_SUCCESS";
export const ACTIVATE_DEACTIVATE_DESIGNATION_FAILURE =
  "ACTIVATE_DEACTIVATE_DESIGNATION_FAILURE";
// designation Action Types - END

// committees Action Types - START
export const FETCH_COMMITTEES_REQUEST = "FETCH_COMMITTEES_REQUEST";
export const FETCH_COMMITTEES_SUCCESS = "FETCH_COMMITTEES_SUCCESS";
export const FETCH_COMMITTEES_FAILURE = "FETCH_COMMITTEES_FAILURE";

export const DELETE_COMMITTEES_REQUEST = "DELETE_COMMITTEES_REQUEST";
export const DELETE_COMMITTEES_SUCCESS = "DELETE_COMMITTEES_SUCCESS";
export const DELETE_COMMITTEES_FAILURE = "DELETE_COMMITTEES_FAILURE";

export const SAVE_COMMITTEES_REQUEST = "SAVE_COMMITTEES_REQUEST";
export const SAVE_COMMITTEES_SUCCESS = "SAVE_COMMITTEES_SUCCESS";
export const SAVE_COMMITTEES_FAILURE = "SAVE_COMMITTEES_FAILURE";

export const FETCH_COMMITTEES_BY_ID_REQUEST = "FETCH_COMMITTEES_BY_ID_REQUEST";
export const FETCH_COMMITTEES_BY_ID_SUCCESS = "FETCH_COMMITTEES_BY_ID_SUCCESS";
export const FETCH_COMMITTEES_BY_ID_FAILURE = "FETCH_COMMITTEES_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_COMMITTEES_REQUEST =
  "ACTIVATE_DEACTIVATE_COMMITTEES_REQUEST";
export const ACTIVATE_DEACTIVATE_COMMITTEES_SUCCESS =
  "ACTIVATE_DEACTIVATE_COMMITTEES_SUCCESS";
export const ACTIVATE_DEACTIVATE_COMMITTEES_FAILURE =
  "ACTIVATE_DEACTIVATE_COMMITTEES_FAILURE";
// committees Action Types - END

// futureSectionChange Action Types - START
export const FETCH_FUTURE_SECTION_CHANGE_REQUEST =
  "FETCH_FUTURE_SECTION_CHANGE_REQUEST";
export const FETCH_FUTURE_SECTION_CHANGE_SUCCESS =
  "FETCH_FUTURE_SECTION_CHANGE_SUCCESS";
export const FETCH_FUTURE_SECTION_CHANGE_FAILURE =
  "FETCH_FUTURE_SECTION_CHANGE_FAILURE";

export const DELETE_FUTURE_SECTION_CHANGE_REQUEST =
  "DELETE_FUTURE_SECTION_CHANGE_REQUEST";
export const DELETE_FUTURE_SECTION_CHANGE_SUCCESS =
  "DELETE_FUTURE_SECTION_CHANGE_SUCCESS";
export const DELETE_FUTURE_SECTION_CHANGE_FAILURE =
  "DELETE_FUTURE_SECTION_CHANGE_FAILURE";

export const SAVE_FUTURE_SECTION_CHANGE_REQUEST =
  "SAVE_FUTURE_SECTION_CHANGE_REQUEST";
export const SAVE_FUTURE_SECTION_CHANGE_SUCCESS =
  "SAVE_FUTURE_SECTION_CHANGE_SUCCESS";
export const SAVE_FUTURE_SECTION_CHANGE_FAILURE =
  "SAVE_FUTURE_SECTION_CHANGE_FAILURE";

export const FETCH_FUTURE_SECTION_CHANGE_BY_ID_REQUEST =
  "FETCH_FUTURE_SECTION_CHANGE_BY_ID_REQUEST";
export const FETCH_FUTURE_SECTION_CHANGE_BY_ID_SUCCESS =
  "FETCH_FUTURE_SECTION_CHANGE_BY_ID_SUCCESS";
export const FETCH_FUTURE_SECTION_CHANGE_BY_ID_FAILURE =
  "FETCH_FUTURE_SECTION_CHANGE_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_REQUEST =
  "ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_REQUEST";
export const ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_SUCCESS =
  "ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_SUCCESS";
export const ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_FAILURE =
  "ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_FAILURE";
// committees Action Types - END

// Schedule Type Action Types
export const FETCH_SCHEDULETYPE_REQUEST = "FETCH_SCHEDULETYPE_REQUEST";
export const FETCH_SCHEDULETYPE_SUCCESS = "FETCH_SCHEDULETYPE_SUCCESS";
export const FETCH_SCHEDULETYPE_FAILURE = "FETCH_SCHEDULETYPE_FAILURE";

export const DELETE_SCHEDULETYPE_REQUEST = "DELETE_SCHEDULETYPE_REQUEST";
export const DELETE_SCHEDULETYPE_SUCCESS = "DELETE_SCHEDULETYPE_SUCCESS";
export const DELETE_SCHEDULETYPE_FAILURE = "DELETE_SCHEDULETYPE_FAILURE";

export const SAVE_SCHEDULETYPE_REQUEST = "SAVE_SCHEDULETYPE_REQUEST";
export const SAVE_SCHEDULETYPE_SUCCESS = "SAVE_SCHEDULETYPE_SUCCESS";
export const SAVE_SCHEDULETYPE_FAILURE = "SAVE_SCHEDULETYPE_FAILURE";

export const FETCH_SCHEDULETYPE_BY_ID_REQUEST =
  "FETCH_SCHEDULETYPE_BY_ID_REQUEST";
export const FETCH_SCHEDULETYPE_BY_ID_SUCCESS =
  "FETCH_SCHEDULETYPE_BY_ID_SUCCESS";
export const FETCH_SCHEDULETYPE_BY_ID_FAILURE =
  "FETCH_SCHEDULETYPE_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_SCHEDULETYPE_REQUEST =
  "ACTIVATE_DEACTIVATE_SCHEDULETYPE_REQUEST";
export const ACTIVATE_DEACTIVATE_SCHEDULETYPE_SUCCESS =
  "ACTIVATE_DEACTIVATE_SCHEDULETYPE_SUCCESS";
export const ACTIVATE_DEACTIVATE_SCHEDULETYPE_FAILURE =
  "ACTIVATE_DEACTIVATE_SCHEDULETYPE_FAILURE";

export const DROPDOWN_SCHEDULETYPE_REQUEST = "DROPDOWN_SCHEDULETYPE_REQUEST";
export const DROPDOWN_SCHEDULETYPE_SUCCESS = "DROPDOWN_SCHEDULETYPE_SUCCESS";
export const DROPDOWN_SCHEDULETYPE_FAILURE = "DROPDOWN_SCHEDULETYPE_FAILURE";

// RadCommunicationType Action Types
export const FETCH_RAD_COMMUNICATION_TYPE_REQUEST =
  "FETCH_RAD_COMMUNICATION_TYPE_REQUEST";
export const FETCH_RAD_COMMUNICATION_TYPE_SUCCESS =
  "FETCH_RAD_COMMUNICATION_TYPE_SUCCESS";
export const FETCH_RAD_COMMUNICATION_TYPE_FAILURE =
  "FETCH_RAD_COMMUNICATION_TYPE_FAILURE";

export const DELETE_RAD_COMMUNICATION_TYPE_REQUEST =
  "DELETE_RAD_COMMUNICATION_TYPE_REQUEST";
export const DELETE_RAD_COMMUNICATION_TYPE_SUCCESS =
  "DELETE_RAD_COMMUNICATION_TYPE_SUCCESS";
export const DELETE_RAD_COMMUNICATION_TYPE_FAILURE =
  "DELETE_RAD_COMMUNICATION_TYPE_FAILURE";

export const SAVE_RAD_COMMUNICATION_TYPE_REQUEST =
  "SAVE_RAD_COMMUNICATION_TYPE_REQUEST";
export const SAVE_RAD_COMMUNICATION_TYPE_SUCCESS =
  "SAVE_RAD_COMMUNICATION_TYPE_SUCCESS";
export const SAVE_RAD_COMMUNICATION_TYPE_FAILURE =
  "SAVE_RAD_COMMUNICATION_TYPE_FAILURE";

export const FETCH_RAD_COMMUNICATION_TYPE_BY_ID_REQUEST =
  "FETCH_RAD_COMMUNICATION_TYPE_BY_ID_REQUEST";
export const FETCH_RAD_COMMUNICATION_TYPE_BY_ID_SUCCESS =
  "FETCH_RAD_COMMUNICATION_TYPE_BY_ID_SUCCESS";
export const FETCH_RAD_COMMUNICATION_TYPE_BY_ID_FAILURE =
  "FETCH_RAD_COMMUNICATION_TYPE_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_REQUEST =
  "ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_REQUEST";
export const ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_SUCCESS =
  "ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_SUCCESS";
export const ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_FAILURE =
  "ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_FAILURE";

export const FETCH_RVURATE_REQUEST = "FETCH_RVURATE_REQUEST";
export const FETCH_RVURATE_SUCCESS = "FETCH_RVURATE_SUCCESS";
export const FETCH_RVURATE_FAILURE = "FETCH_RVURATE_FAILURE";

export const FETCH_RVURATE_BY_ID_REQUEST = "FETCH_RVURATE_BY_ID_REQUEST";
export const FETCH_RVURATE_BY_ID_SUCCESS = "FETCH_RVURATE_BY_ID_SUCCESS";
export const FETCH_RVURATE_BY_ID_FAILURE = "FETCH_RVURATE_BY_ID_FAILURE";

export const SAVE_RVURATE_REQUEST = "SAVE_RVURATE_REQUEST";
export const SAVE_RVURATE_SUCCESS = "SAVE_RVURATE_SUCCESS";
export const SAVE_RVURATE_FAILURE = "SAVE_RVURATE_FAILURE";

export const DELETE_RVURATE_REQUEST = "DELETE_RVURATE_REQUEST";
export const DELETE_RVURATE_SUCCESS = "DELETE_RVURATE_SUCCESS";
export const DELETE_RVURATE_FAILURE = "DELETE_RVURATE_FAILURE";

export const ACTIVATE_DEACTIVATE_RVURATE_REQUEST =
  "ACTIVATE_DEACTIVATE_RVURATE_REQUEST";
export const ACTIVATE_DEACTIVATE_RVURATE_SUCCESS =
  "ACTIVATE_DEACTIVATE_RVURATE_SUCCESS";
export const ACTIVATE_DEACTIVATE_RVURATE_FAILURE =
  "ACTIVATE_DEACTIVATE_RVURATE_FAILURE";

export const FETCH_TIME_ZONES_REQUEST = "FETCH_TIME_ZONES_REQUEST";
export const FETCH_TIME_ZONES_SUCCESS = "FETCH_TIME_ZONES_SUCCESS";
export const FETCH_TIME_ZONES_FAILURE = "FETCH_TIME_ZONES_FAILURE";

export const SAVE_TIME_ZONE_REQUEST = "SAVE_TIME_ZONE_REQUEST";
export const SAVE_TIME_ZONE_SUCCESS = "SAVE_TIME_ZONE_SUCCESS";
export const SAVE_TIME_ZONE_FAILURE = "SAVE_TIME_ZONE_FAILURE";

export const DELETE_TIME_ZONE_REQUEST = "DELETE_TIME_ZONE_REQUEST";
export const DELETE_TIME_ZONE_SUCCESS = "DELETE_TIME_ZONE_SUCCESS";
export const DELETE_TIME_ZONE_FAILURE = "DELETE_TIME_ZONE_FAILURE";

export const ACTIVATE_DEACTIVATE_TIME_ZONE_REQUEST =
  "ACTIVATE_DEACTIVATE_TIME_ZONE_REQUEST";
export const ACTIVATE_DEACTIVATE_TIME_ZONE_SUCCESS =
  "ACTIVATE_DEACTIVATE_TIME_ZONE_SUCCESS";
export const ACTIVATE_DEACTIVATE_TIME_ZONE_FAILURE =
  "ACTIVATE_DEACTIVATE_TIME_ZONE_FAILURE";

export const FETCH_TIME_ZONE_BY_ID_REQUEST = "FETCH_TIME_ZONE_BY_ID_REQUEST";
export const FETCH_TIME_ZONE_BY_ID_SUCCESS = "FETCH_TIME_ZONE_BY_ID_SUCCESS";
export const FETCH_TIME_ZONE_BY_ID_FAILURE = "FETCH_TIME_ZONE_BY_ID_FAILURE";

// Request Status Type Action Types
export const FETCH_REQUESTSTATUS_REQUEST = "FETCH_REQUESTSTATUS_REQUEST";
export const FETCH_REQUESTSTATUS_SUCCESS = "FETCH_REQUESTSTATUS_SUCCESS";
export const FETCH_REQUESTSTATUS_FAILURE = "FETCH_REQUESTSTATUS_FAILURE";

export const SAVE_REQUESTSTATUS_REQUEST = "SAVE_REQUESTSTATUS_REQUEST";
export const SAVE_REQUESTSTATUS_SUCCESS = "SAVE_REQUESTSTATUS_SUCCESS";
export const SAVE_REQUESTSTATUS_FAILURE = "SAVE_REQUESTSTATUS_FAILURE";

export const FETCH_REQUESTSTATUS_BY_ID_REQUEST =
  "FETCH_REQUESTSTATUS_BY_ID_REQUEST";
export const FETCH_REQUESTSTATUS_BY_ID_SUCCESS =
  "FETCH_REQUESTSTATUS_BY_ID_SUCCESS";
export const FETCH_REQUESTSTATUS_BY_ID_FAILURE =
  "FETCH_REQUESTSTATUS_BY_ID_FAILURE";

export const DELETE_REQUESTSTATUS_REQUEST = "DELETE_REQUESTSTATUS_REQUEST";
export const DELETE_REQUESTSTATUS_SUCCESS = "DELETE_REQUESTSTATUS_SUCCESS";
export const DELETE_REQUESTSTATUS_FAILURE = "DELETE_REQUESTSTATUS_FAILURE";

export const ACTIVATE_DEACTIVATE_REQUEST_STATUS_REQUEST =
  "ACTIVATE_DEACTIVATE_REQUEST_STATUS_REQUEST";
export const ACTIVATE_DEACTIVATE_REQUEST_STATUS_SUCCESS =
  "ACTIVATE_DEACTIVATE_REQUEST_STATUS_SUCCESS";
export const ACTIVATE_DEACTIVATE_REQUEST_STATUS_FAILURE =
  "ACTIVATE_DEACTIVATE_REQUEST_STATUS_FAILURE";
// Trauma Facility Level Mapping Action Types - start

export const FETCH_TRAUMAFACILITYLEVEL_REQUEST =
  "FETCH_TRAUMAFACILITYLEVEL_REQUEST";
export const FETCH_TRAUMAFACILITYLEVEL_SUCCESS =
  "FETCH_TRAUMAFACILITYLEVEL_SUCCESS";
export const FETCH_TRAUMAFACILITYLEVEL_FAILURE =
  "FETCH_TRAUMAFACILITYLEVEL_FAILURE";

export const DELETE_TRAUMAFACILITYLEVEL_REQUEST =
  "DELETE_TRAUMAFACILITYLEVEL_REQUEST";
export const DELETE_TRAUMAFACILITYLEVEL_SUCCESS =
  "DELETE_TRAUMAFACILITYLEVEL_SUCCESS";
export const DELETE_TRAUMAFACILITYLEVEL_FAILURE =
  "DELETE_TRAUMAFACILITYLEVEL_FAILURE";

export const ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_REQUEST =
  "ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_REQUEST";
export const ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_SUCCESS =
  "ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_SUCCESS";
export const ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_FAILURE =
  "ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_FAILURE";

export const SAVE_TRAUMAFACILITYLEVEL_REQUEST =
  "SAVE_TRAUMAFACILITYLEVEL_REQUEST";
export const SAVE_TRAUMAFACILITYLEVEL_SUCCESS =
  "SAVE_TRAUMAFACILITYLEVEL_SUCCESS";
export const SAVE_TRAUMAFACILITYLEVEL_FAILURE =
  "SAVE_TRAUMAFACILITYLEVEL_FAILURE";

export const FETCH_TRAUMAFACILITYLEVEL_BY_ID_REQUEST =
  "FETCH_TRAUMAFACILITYLEVEL_BY_ID_REQUEST";
export const FETCH_TRAUMAFACILITYLEVEL_BY_ID_SUCCESS =
  "FETCH_TRAUMAFACILITYLEVEL_BY_ID_SUCCESS";
export const FETCH_TRAUMAFACILITYLEVEL_BY_ID_FAILURE =
  "FETCH_TRAUMAFACILITYLEVEL_BY_ID_FAILURE";

// Trauma Facility Level Mapping Action Types - end

// Qgenda Section Action Types
export const FETCH_QGENDA_SECTION_REQUEST = "FETCH_QGENDA_SECTION_REQUEST";
export const FETCH_QGENDA_SECTION_SUCCESS = "FETCH_QGENDA_SECTION_SUCCESS";
export const FETCH_QGENDA_SECTION_FAILURE = "FETCH_QGENDA_SECTION_FAILURE";

export const FETCH_QGENDA_SECTION_BY_ID_REQUEST =
  "FETCH_QGENDA_SECTION_BY_ID_REQUEST";
export const FETCH_QGENDA_SECTION_BY_ID_SUCCESS =
  "FETCH_QGENDA_SECTION_BY_ID_SUCCESS";
export const FETCH_QGENDA_SECTION_BY_ID_FAILURE =
  "FETCH_QGENDA_SECTION_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_QGENDA_SECTION_REQUEST =
  "ACTIVATE_DEACTIVATE_QGENDA_SECTION_REQUEST";
export const ACTIVATE_DEACTIVATE_QGENDA_SECTION_SUCCESS =
  "ACTIVATE_DEACTIVATE_QGENDA_SECTION_SUCCESS";
export const ACTIVATE_DEACTIVATE_QGENDA_SECTION_FAILURE =
  "ACTIVATE_DEACTIVATE_QGENDA_SECTION_FAILURE";

export const SAVE_QGENDA_SECTION_REQUEST = "SAVE_QGENDA_SECTION_REQUEST";
export const SAVE_QGENDA_SECTION_SUCCESS = "SAVE_QGENDA_SECTION_SUCCESS";
export const SAVE_QGENDA_SECTION_FAILURE = "SAVE_QGENDA_SECTION_FAILURE";

export const DELETE_QGENDA_SECTION_REQUEST = "DELETE_QGENDA_SECTION_REQUEST";
export const DELETE_QGENDA_SECTION_SUCCESS = "DELETE_QGENDA_SECTION_SUCCESS";
export const DELETE_QGENDA_SECTION_FAILURE = "DELETE_QGENDA_SECTION_FAILURE";

// SiteStatus Action Types
export const FETCH_SITE_STATUS_REQUEST = "FETCH_SITE_STATUS_REQUEST";
export const FETCH_SITE_STATUS_SUCCESS = "FETCH_SITE_STATUS_SUCCESS";
export const FETCH_SITE_STATUS_FAILURE = "FETCH_SITE_STATUS_FAILURE";

export const FETCH_SITE_STATUS_BY_ID_REQUEST =
  "FETCH_SITE_STATUS_BY_ID_REQUEST";
export const FETCH_SITE_STATUS_BY_ID_SUCCESS =
  "FETCH_SITE_STATUS_BY_ID_SUCCESS";
export const FETCH_SITE_STATUS_BY_ID_FAILURE =
  "FETCH_SITE_STATUS_BY_ID_FAILURE";

export const SAVE_SITE_STATUS_REQUEST = "SAVE_SITE_STATUS_REQUEST";
export const SAVE_SITE_STATUS_SUCCESS = "SAVE_SITE_STATUS_SUCCESS";
export const SAVE_SITE_STATUS_FAILURE = "SAVE_SITE_STATUS_FAILURE";

export const DELETE_SITE_STATUS_REQUEST = "DELETE_SITE_STATUS_REQUEST";
export const DELETE_SITE_STATUS_SUCCESS = "DELETE_SITE_STATUS_SUCCESS";
export const DELETE_SITE_STATUS_FAILURE = "DELETE_SITE_STATUS_FAILURE";

export const ACTIVATE_DEACTIVATE_SITE_STATUS_REQUEST =
  "ACTIVATE_DEACTIVATE_SITE_STATUS_REQUEST";
export const ACTIVATE_DEACTIVATE_SITE_STATUS_SUCCESS =
  "ACTIVATE_DEACTIVATE_SITE_STATUS_SUCCESS";
export const ACTIVATE_DEACTIVATE_SITE_STATUS_FAILURE =
  "ACTIVATE_DEACTIVATE_SITE_STATUS_FAILURE";

//Modality Action Types
export const FETCH_MODALITY_REQUEST = "FETCH_MODALITY_REQUEST";
export const FETCH_MODALITY_SUCCESS = "FETCH_MODALITY_SUCCESS";
export const FETCH_MODALITY_FAILURE = "FETCH_MODALITY_FAILURE";

export const FETCH_MODALITY_BY_ID_REQUEST = "FETCH_MODALITY_BY_ID_REQUEST";
export const FETCH_MODALITY_BY_ID_SUCCESS = "FETCH_MODALITY_BY_ID_SUCCESS";
export const FETCH_MODALITY_BY_ID_FAILURE = "FETCH_MODALITY_BY_ID_FAILURE";

export const SAVE_MODALITY_REQUEST = "SAVE_MODALITY_REQUEST";
export const SAVE_MODALITY_SUCCESS = "SAVE_MODALITY_SUCCESS";
export const SAVE_MODALITY_FAILURE = "SAVE_MODALITY_FAILURE";

export const DELETE_MODALITY_REQUEST = "DELETE_MODALITY_REQUEST";
export const DELETE_MODALITY_SUCCESS = "DELETE_MODALITY_SUCCESS";
export const DELETE_MODALITY_FAILURE = "DELETE_MODALITY_FAILURE";

export const ACTIVATE_DEACTIVATE_MODALITY_REQUEST =
  "ACTIVATE_DEACTIVATE_MODALITY_REQUEST";
export const ACTIVATE_DEACTIVATE_MODALITY_SUCCESS =
  "ACTIVATE_DEACTIVATE_MODALITY_SUCCESS";
export const ACTIVATE_DEACTIVATE_MODALITY_FAILURE =
  "ACTIVATE_DEACTIVATE_MODALITY_FAILURE";

//Priority Action Types
export const FETCH_PRIORITY_REQUEST = "FETCH_PRIORITY_REQUEST";
export const FETCH_PRIORITY_SUCCESS = "FETCH_PRIORITY_SUCCESS";
export const FETCH_PRIORITY_FAILURE = "FETCH_PRIORITY_FAILURE";

export const FETCH_PRIORITY_BY_ID_REQUEST = "FETCH_PRIORITY_BY_ID_REQUEST";
export const FETCH_PRIORITY_BY_ID_SUCCESS = "FETCH_PRIORITY_BY_ID_SUCCESS";
export const FETCH_PRIORITY_BY_ID_FAILURE = "FETCH_PRIORITY_BY_ID_FAILURE";

export const SAVE_PRIORITY_REQUEST = "SAVE_PRIORITY_REQUEST";
export const SAVE_PRIORITY_SUCCESS = "SAVE_PRIORITY_SUCCESS";
export const SAVE_PRIORITY_FAILURE = "SAVE_PRIORITY_FAILURE";

export const DELETE_PRIORITY_REQUEST = "DELETE_PRIORITY_REQUEST";
export const DELETE_PRIORITY_SUCCESS = "DELETE_PRIORITY_SUCCESS";
export const DELETE_PRIORITY_FAILURE = "DELETE_PRIORITY_FAILURE";

export const ACTIVATE_DEACTIVATE_PRIORITY_REQUEST =
  "ACTIVATE_DEACTIVATE_PRIORITY_REQUEST";
export const ACTIVATE_DEACTIVATE_PRIORITY_SUCCESS =
  "ACTIVATE_DEACTIVATE_PRIORITY_SUCCESS";
export const ACTIVATE_DEACTIVATE_PRIORITY_FAILURE =
  "ACTIVATE_DEACTIVATE_PRIORITY_FAILURE";

//Priority Bucket Action Types
export const FETCH_PRIORITY_BUCKETS_REQUEST = "FETCH_PRIORITY_BUCKETS_REQUEST";
export const FETCH_PRIORITY_BUCKETS_SUCCESS = "FETCH_PRIORITY_BUCKETS_SUCCESS";
export const FETCH_PRIORITY_BUCKETS_FAILURE = "FETCH_PRIORITY_BUCKETS_FAILURE";

export const FETCH_STAFF_CATEGORIES_REQUEST = "FETCH_STAFF_CATEGORIES_REQUEST";
export const FETCH_STAFF_CATEGORIES_SUCCESS = "FETCH_STAFF_CATEGORIES_SUCCESS";
export const FETCH_STAFF_CATEGORIES_FAILURE = "FETCH_STAFF_CATEGORIES_FAILURE";

export const FETCH_STAFF_CATEGORY_BY_ID_REQUEST =
  "FETCH_STAFF_CATEGORY_BY_ID_REQUEST";
export const FETCH_STAFF_CATEGORY_BY_ID_SUCCESS =
  "FETCH_STAFF_CATEGORY_BY_ID_SUCCESS";
export const FETCH_STAFF_CATEGORY_BY_ID_FAILURE =
  "FETCH_STAFF_CATEGORY_BY_ID_FAILURE";

export const SAVE_STAFF_CATEGORY_REQUEST = "SAVE_STAFF_CATEGORY_REQUEST";
export const SAVE_STAFF_CATEGORY_SUCCESS = "SAVE_STAFF_CATEGORY_SUCCESS";
export const SAVE_STAFF_CATEGORY_FAILURE = "SAVE_STAFF_CATEGORY_FAILURE";

export const DELETE_STAFF_CATEGORY_REQUEST = "DELETE_STAFF_CATEGORY_REQUEST";
export const DELETE_STAFF_CATEGORY_SUCCESS = "DELETE_STAFF_CATEGORY_SUCCESS";
export const DELETE_STAFF_CATEGORY_FAILURE = "DELETE_STAFF_CATEGORY_FAILURE";

export const ACTIVATE_DEACTIVATE_STAFF_CATEGORY_REQUEST =
  "ACTIVATE_DEACTIVATE_STAFF_CATEGORY_REQUEST";
export const ACTIVATE_DEACTIVATE_STAFF_CATEGORY_SUCCESS =
  "ACTIVATE_DEACTIVATE_STAFF_CATEGORY_SUCCESS";
export const ACTIVATE_DEACTIVATE_STAFF_CATEGORY_FAILURE =
  "ACTIVATE_DEACTIVATE_STAFF_CATEGORY_FAILURE";

// Staff Primary Location
export const FETCH_STAFF_PRIMARY_LOCATIONS_REQUEST =
  "FETCH_STAFF_PRIMARY_LOCATIONS_REQUEST";
export const FETCH_STAFF_PRIMARY_LOCATIONS_SUCCESS =
  "FETCH_STAFF_PRIMARY_LOCATIONS_SUCCESS";
export const FETCH_STAFF_PRIMARY_LOCATIONS_FAILURE =
  "FETCH_STAFF_PRIMARY_LOCATIONS_FAILURE";

export const FETCH_STAFF_PRIMARY_LOCATION_BY_ID_REQUEST =
  "FETCH_STAFF_PRIMARY_LOCATION_BY_ID_REQUEST";
export const FETCH_STAFF_PRIMARY_LOCATION_BY_ID_SUCCESS =
  "FETCH_STAFF_PRIMARY_LOCATION_BY_ID_SUCCESS";
export const FETCH_STAFF_PRIMARY_LOCATION_BY_ID_FAILURE =
  "FETCH_STAFF_PRIMARY_LOCATION_BY_ID_FAILURE";

export const SAVE_STAFF_PRIMARY_LOCATION_REQUEST =
  "SAVE_STAFF_PRIMARY_LOCATION_REQUEST";
export const SAVE_STAFF_PRIMARY_LOCATION_SUCCESS =
  "SAVE_STAFF_PRIMARY_LOCATION_SUCCESS";
export const SAVE_STAFF_PRIMARY_LOCATION_FAILURE =
  "SAVE_STAFF_PRIMARY_LOCATION_FAILURE";

export const DELETE_STAFF_PRIMARY_LOCATION_REQUEST =
  "DELETE_STAFF_PRIMARY_LOCATION_REQUEST";
export const DELETE_STAFF_PRIMARY_LOCATION_SUCCESS =
  "DELETE_STAFF_PRIMARY_LOCATION_SUCCESS";
export const DELETE_STAFF_PRIMARY_LOCATION_FAILURE =
  "DELETE_STAFF_PRIMARY_LOCATION_FAILURE";

export const ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_REQUEST =
  "ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_REQUEST";
export const ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_SUCCESS =
  "ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_SUCCESS";
export const ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_FAILURE =
  "ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_FAILURE";

// Specialty Cases Action Types - START
export const FETCH_SPECIALTY_CASES_REQUEST = "FETCH_SPECIALTY_CASES_REQUEST";
export const FETCH_SPECIALTY_CASES_SUCCESS = "FETCH_SPECIALTY_CASES_SUCCESS";
export const FETCH_SPECIALTY_CASES_FAILURE = "FETCH_SPECIALTY_CASES_FAILURE";

export const DELETE_SPECIALTY_CASES_REQUEST = "DELETE_SPECIALTY_CASES_REQUEST";
export const DELETE_SPECIALTY_CASES_SUCCESS = "DELETE_SPECIALTY_CASES_SUCCESS";
export const DELETE_SPECIALTY_CASES_FAILURE = "DELETE_SPECIALTY_CASES_FAILURE";

export const SAVE_SPECIALTY_CASES_REQUEST = "SAVE_SPECIALTY_CASES_REQUEST";
export const SAVE_SPECIALTY_CASES_SUCCESS = "SAVE_SPECIALTY_CASES_SUCCESS";
export const SAVE_SPECIALTY_CASES_FAILURE = "SAVE_SPECIALTY_CASES_FAILURE";

export const FETCH_SPECIALTY_CASES_BY_ID_REQUEST =
  "FETCH_SPECIALTY_CASES_BY_ID_REQUEST";
export const FETCH_SPECIALTY_CASES_BY_ID_SUCCESS =
  "FETCH_SPECIALTY_CASES_BY_ID_SUCCESS";
export const FETCH_SPECIALTY_CASES_BY_ID_FAILURE =
  "FETCH_SPECIALTY_CASES_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_SPECIALTY_CASES_REQUEST =
  "ACTIVATE_DEACTIVATE_SPECIALTY_CASES_REQUEST";
export const ACTIVATE_DEACTIVATE_SPECIALTY_CASES_SUCCESS =
  "ACTIVATE_DEACTIVATE_SPECIALTY_CASES_SUCCESS";
export const ACTIVATE_DEACTIVATE_SPECIALTY_CASES_FAILURE =
  "ACTIVATE_DEACTIVATE_SPECIALTY_CASES_FAILURE";
// Specialty Cases Action Types - END

// Staffing Agency Action Types - START
export const FETCH_STAFFING_AGENCY_REQUEST = "FETCH_STAFFING_AGENCY_REQUEST";
export const FETCH_STAFFING_AGENCY_SUCCESS = "FETCH_STAFFING_AGENCY_SUCCESS";
export const FETCH_STAFFING_AGENCY_FAILURE = "FETCH_STAFFING_AGENCY_FAILURE";

export const DELETE_STAFFING_AGENCY_REQUEST = "DELETE_STAFFING_AGENCY_REQUEST";
export const DELETE_STAFFING_AGENCY_SUCCESS = "DELETE_STAFFING_AGENCY_SUCCESS";
export const DELETE_STAFFING_AGENCY_FAILURE = "DELETE_STAFFING_AGENCY_FAILURE";

export const SAVE_STAFFING_AGENCY_REQUEST = "SAVE_STAFFING_AGENCY_REQUEST";
export const SAVE_STAFFING_AGENCY_SUCCESS = "SAVE_STAFFING_AGENCY_SUCCESS";
export const SAVE_STAFFING_AGENCY_FAILURE = "SAVE_STAFFING_AGENCY_FAILURE";

export const FETCH_STAFFING_AGENCY_BY_ID_REQUEST =
  "FETCH_STAFFING_AGENCY_BY_ID_REQUEST";
export const FETCH_STAFFING_AGENCY_BY_ID_SUCCESS =
  "FETCH_STAFFING_AGENCY_BY_ID_SUCCESS";
export const FETCH_STAFFING_AGENCY_BY_ID_FAILURE =
  "FETCH_STAFFING_AGENCY_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_STAFFING_AGENCY_REQUEST =
  "ACTIVATE_DEACTIVATE_STAFFING_AGENCY_REQUEST";
export const ACTIVATE_DEACTIVATE_STAFFING_AGENCY_SUCCESS =
  "ACTIVATE_DEACTIVATE_STAFFING_AGENCY_SUCCESS";
export const ACTIVATE_DEACTIVATE_STAFFING_AGENCY_FAILURE =
  "ACTIVATE_DEACTIVATE_STAFFING_AGENCY_FAILURE";
// Staffing Agency Action Types - END

// DOCUMENT Type Action Types
export const FETCH_PROVIDER_DOCUMENTTYPES_REQUEST =
  "FETCH_PROVIDER_DOCUMENTTYPES_REQUEST";
export const FETCH_PROVIDER_DOCUMENTTYPES_SUCCESS =
  "FETCH_PROVIDER_DOCUMENTTYPES_SUCCESS";
export const FETCH_PROVIDER_DOCUMENTTYPES_FAILURE =
  "FETCH_PROVIDER_DOCUMENTTYPES_FAILURE";

export const DELETE_PROVIDER_DOCUMENTTYPE_REQUEST =
  "DELETE_PROVIDER_DOCUMENTTYPE_REQUEST";
export const DELETE_PROVIDER_DOCUMENTTYPE_SUCCESS =
  "DELETE_PROVIDER_DOCUMENTTYPE_SUCCESS";
export const DELETE_PROVIDER_DOCUMENTTYPE_FAILURE =
  "DELETE_PROVIDER_DOCUMENTTYPE_FAILURE";

export const SAVE_PROVIDER_DOCUMENTTYPE_REQUEST =
  "SAVE_PROVIDER_DOCUMENTTYPE_REQUEST";
export const SAVE_PROVIDER_DOCUMENTTYPE_SUCCESS =
  "SAVE_PROVIDER_DOCUMENTTYPE_SUCCESS";
export const SAVE_PROVIDER_DOCUMENTTYPE_FAILURE =
  "SAVE_PROVIDER_DOCUMENTTYPE_FAILURE";

export const FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_REQUEST =
  "FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_REQUEST";
export const FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_SUCCESS =
  "FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_SUCCESS";
export const FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_FAILURE =
  "FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_FAILURE";

export const UPDATE_PROVIDER_DOCUMENTTYPE_REQUEST =
  "UPDATE_PROVIDER_DOCUMENTTYPE_REQUEST";
export const UPDATE_PROVIDER_DOCUMENTTYPE_SUCCESS =
  "UPDATE_PROVIDER_DOCUMENTTYPE_SUCCESS";
export const UPDATE_PROVIDER_DOCUMENTTYPE_FAILURE =
  "UPDATE_PROVIDER_DOCUMENTTYPE_FAILURE";

export const ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_REQUEST =
  "ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_REQUEST";
export const ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_SUCCESS =
  "ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_SUCCESS";
export const ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_FAILURE =
  "ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_FAILURE";

// Provider Note Type Action Types
export const FETCH_PROVIDER_NOTETYPES_REQUEST =
  "FETCH_PROVIDER_NOTETYPES_REQUEST";
export const FETCH_PROVIDER_NOTETYPES_SUCCESS =
  "FETCH_PROVIDER_NOTETYPES_SUCCESS";
export const FETCH_PROVIDER_NOTETYPES_FAILURE =
  "FETCH_PROVIDER_NOTETYPES_FAILURE";

export const DELETE_PROVIDER_NOTETYPE_REQUEST =
  "DELETE_PROVIDER_NOTETYPE_REQUEST";
export const DELETE_PROVIDER_NOTETYPE_SUCCESS =
  "DELETE_PROVIDER_NOTETYPE_SUCCESS";
export const DELETE_PROVIDER_NOTETYPE_FAILURE =
  "DELETE_PROVIDER_NOTETYPE_FAILURE";

export const SAVE_PROVIDER_NOTETYPE_REQUEST = "SAVE_PROVIDER_NOTETYPE_REQUEST";
export const SAVE_PROVIDER_NOTETYPE_SUCCESS = "SAVE_PROVIDER_NOTETYPE_SUCCESS";
export const SAVE_PROVIDER_NOTETYPE_FAILURE = "SAVE_PROVIDER_NOTETYPE_FAILURE";

export const FETCH_PROVIDER_NOTETYPE_BY_ID_REQUEST =
  "FETCH_PROVIDER_NOTETYPE_BY_ID_REQUEST";
export const FETCH_PROVIDER_NOTETYPE_BY_ID_SUCCESS =
  "FETCH_PROVIDER_NOTETYPE_BY_ID_SUCCESS";
export const FETCH_PROVIDER_NOTETYPE_BY_ID_FAILURE =
  "FETCH_PROVIDER_NOTETYPE_BY_ID_FAILURE";

export const ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_REQUEST =
  "ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_REQUEST";
export const ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_SUCCESS =
  "ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_SUCCESS";
export const ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_FAILURE =
  "ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_FAILURE";

// Common Action Types
export const UPDATE_DROPDOWN_MANAGEMENT_REDUCER =
  "UPDATE_DROPDOWN_MANAGEMENT_REDUCER";
